import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'lib/utils'
import * as React from 'react'

const labelVariants = cva(
  'font-inter text-secondary text-s-500 tracking-normal peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

const OptionalLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ children, ...props }, ref) => (
  <Label ref={ref} {...props}>
    {children}
    <span className="text-tertiary text-s-400 italic ml-1">(optional)</span>
  </Label>
))
OptionalLabel.displayName = 'OptionalLabel'

export { Label, OptionalLabel }
